import { render } from "./DownloadMerchant.vue?vue&type=template&id=55d6ef1c&scoped=true"
import script from "./DownloadMerchant.vue?vue&type=script&lang=js"
export * from "./DownloadMerchant.vue?vue&type=script&lang=js"

import "./DownloadMerchant.vue?vue&type=style&index=0&id=55d6ef1c&scoped=true&lang=scss"
import "./DownloadMerchant.vue?vue&type=style&index=1&id=55d6ef1c&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d6ef1c"]])

export default __exports__